/**
 * @module components/XAxisSetting/XAxisSortBy
 * @description X 轴排序 — UI 复用 SortByPanel，状态由 useXAxisSortDraft 管理
 */

import React from 'react';
import SortByPanel from '../../common/SortByPanel';
import type { IXAxisSortByProps } from './types';
import { useXAxisSortDraft } from './useXAxisSortDraft';

const XAxisSortBy: React.FC<IXAxisSortByProps> = ({ visibleItems }) => {
  const viewModel = useXAxisSortDraft({ visibleItems });
  return <SortByPanel {...viewModel} />;
};

export default React.memo(XAxisSortBy);
